import { useFeatureFlags } from '@usap/core'

/**
 * Optimizely feature flag key: `f107` — loyalty global kill switch.
 *
 * Decoupled from the rollout flag `f98` on purpose. f98 buckets users
 * into the A/B test; once enrolled, a customer should keep seeing their
 * loyalty UI on every device regardless of which Optimizely bucket THAT
 * device happens to draw. f107 is the orthogonal "hide all loyalty UI
 * globally" lever — flip it on to roll back without affecting which
 * users are eligible for auto-enrollment.
 *
 * Default behavior (flag absent / "off" / "a") is NOT killed — loyalty
 * UI shows for enrolled customers as normal.
 */
const ENABLED_VALUES = new Set<unknown>(['on', '1', 'b', 'true', 1, true])

const useLoyaltyKilled = (): boolean => {
  const { f107 } = useFeatureFlags()
  if (f107 == null) return false // eslint-disable-line eqeqeq
  return ENABLED_VALUES.has(f107) || ENABLED_VALUES.has(String(f107).toLowerCase())
}

export default useLoyaltyKilled
